import React, { useRef, useState } from 'react';
import { circlePlusIconLightBlack, plusPurpleCircle } from '../../../assets/hostedassets';
import searchIcon from '../../../assets/search-glass.svg';
import { useOutsideClick } from '../../../utils/constants/hooks';
import { StatusDropdownOption } from '../../_custom/StatusDropdown/StatusDropdown';
import { ADD_PARTNER_LABELS } from '../NeedInfoV2Constants';
import styles from './PartnerPickerSheet.module.scss';

type Props = {
    options: StatusDropdownOption[];
    onSelect: (option: StatusDropdownOption) => void;
    onAddNew: () => void;
    triggerLabel: string;
};

// Selection is click-only: Enter never picks a partner, so a stray keypress cannot tag the wrong one.
const PartnerPickerSheet: React.FC<Props> = ({ options, onSelect, onAddNew, triggerLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [term, setTerm] = useState('');
    const rootRef = useRef<HTMLDivElement | null>(null);

    useOutsideClick(rootRef, () => setIsOpen(false));

    const toggle = () => {
        setTerm('');
        setIsOpen((open) => !open);
    };

    const visibleOptions = options.filter((o) => o.label.toLowerCase().includes(term.trim().toLowerCase()));

    return (
        <div ref={rootRef} className={styles.Root} onKeyDown={(e) => e.stopPropagation()}>
            <button type="button" className={styles.Trigger} onClick={toggle}>
                <img src={circlePlusIconLightBlack} alt="" />
                {triggerLabel}
            </button>
            {isOpen && (
                <div className={styles.Sheet}>
                    <div className={styles.SearchRow}>
                        <input
                            className={styles.SearchInput}
                            placeholder={ADD_PARTNER_LABELS.SEARCH_PLACEHOLDER}
                            value={term}
                            autoFocus
                            onChange={(e) => setTerm(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                        />
                        <img src={searchIcon} alt="" data-testid="partner-search-icon" className={styles.SearchIcon} />
                    </div>
                    <ul className={styles.List}>
                        {visibleOptions.length === 0 && <li className={styles.Empty}>{ADD_PARTNER_LABELS.NO_PARTNERS}</li>}
                        {visibleOptions.map((o) => (
                            <li key={o.value}>
                                <button
                                    type="button"
                                    className={styles.Option}
                                    onClick={() => {
                                        onSelect(o);
                                        setIsOpen(false);
                                    }}
                                >
                                    {o.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <button type="button" className={styles.AddNew} onClick={onAddNew}>
                        <img src={plusPurpleCircle} alt="" />
                        {ADD_PARTNER_LABELS.ADD_NEW}
                    </button>
                </div>
            )}
        </div>
    );
};

export default PartnerPickerSheet;
